<template>
  <div>
    <div class="bg-white" v-loading="loading" element-loading-text="拼命加载中">
      <div class="formBox">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
          class="demo-ruleForm"
        >
          <el-row class="paddingleft">
            <div class="bigTit">房屋状况</div>
            <el-col :span="8">
              <el-form-item label="房屋类型：" prop="housetype">
                <el-select
                  v-model="ruleForm.housetype"
                  placeholder="选择房屋类型"
                  filterable
                >
                  <el-option label="独栋别墅" value="独栋别墅"></el-option>
                  <el-option label="联排别墅" value="联排别墅"></el-option>
                  <el-option label="公寓" value="公寓"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="猫：">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.petsituation"
                  placeholder="输入宠物情况"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="狗：">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.dog"
                  placeholder="输入宠物情况"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="paddingleft">
            <el-col :span="8">
              <el-form-item label="其他宠物：">
                <el-input
                  v-model="ruleForm.qita"
                  placeholder="输入其他宠物情况"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="子女情况：" prop="children">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.children"
                  placeholder="输入子女情况"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="有几个孩子同住" prop="ischildren">
                <el-input
                  v-model="ruleForm.ischildren"
                  placeholder="输入有几个孩子与你同住"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="paddingleft" style="padding-bottom: 20px">
            <el-col :span="8">
              <el-form-item label="寄宿经验：" prop="jsexperience">
                <el-select
                  v-model="ruleForm.jsexperience"
                  placeholder="选择寄宿家庭经验"
                  filterable
                >
                  <el-option label="1名" value="1名"></el-option>
                  <el-option label="2~3名" value="2~3名"></el-option>
                  <el-option label="4~5名" value="4~5名"></el-option>
                  <el-option label="6名以上" value="6名以上"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="价格（美元/月）：" prop="money">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.money"
                  placeholder="输入房源价格"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowwhitetopbor">
            <div class="bigTit">房屋设施</div>
            <el-col :span="8">
              <el-form-item label="卧室数量：" prop="bedroom">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.bedroom"
                  placeholder="输入卧室数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="卫浴数量：" prop="bathroom">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.bathroom"
                  placeholder="输入卫浴数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="空闲卧室：" prop="nullbedroom">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.nullbedroom"
                  placeholder="输入空闲卧室数量"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="paddingleft">
            <el-col :span="8">
              <el-form-item label="汽车数量：" prop="car">
                <el-input
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');"
                  v-model="ruleForm.car"
                  placeholder="输入汽车数量"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="独立卫浴：" prop="duwei">
                <el-select
                  v-model="ruleForm.duwei"
                  placeholder="选择独立卫浴"
                  filterable
                >
                  <el-option label="是" value="是"></el-option>
                  <el-option label="否" value="否"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="可签标签：" prop="iskeqian">
                <el-select
                  v-model="ruleForm.iskeqian"
                  placeholder="选择可签标签"
                  filterable
                >
                  <el-option label="可签" value="可签"></el-option>
                  <el-option label="不可签" value="不可签"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row class="rowwhitebombor">
            <el-col :span="8">
              <el-form-item label="包含设施：" prop="facilities">
                <el-select
                  v-model="ruleForm.facilities"
                  multiple
                  placeholder="请选择包含设施"
                  filterable
                >
                  <el-option
                    v-for="item in facilities_options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="房屋视频链接：" prop="video">
                <el-input
                  v-model="ruleForm.video"
                  placeholder="输入房屋视频链接"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="住家签约链接：" prop="video">
                <div>
                  <div class="url">
                    <a :href="SignUrl" target="_blank">{{ SignUrl }}</a>
                  </div>
                  <!-- <button @click="copy(SignUrl)">复制</button> -->
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            class="paddingleft"
            style="padding: 45px 0 20px 45px;"
            v-loading="uploadLoading"
            element-loading-text="拼命上传中"
          >
            <div class="bigTit">房屋图片上传</div>

            <el-col :span="24">
              <div class="upload_video">
                <p>上传视频</p>
                <div>
                  <input type="file" ref="upload" @change="selectFile" />
                </div>
              </div>
            </el-col>

            <el-col :span="24">
              <el-form-item label="封面图">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '5')
                  "
                  :file-list="fileList_5"
                  :on-change="
                    (file, fileList) =>
                      otherSectionFile(file, fileList, '封面图')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="房屋外观">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '0')
                  "
                  :file-list="fileList_0"
                  :on-change="
                    (file, fileList) =>
                      otherSectionFile(file, fileList, '房屋外观')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="寄宿家庭成员">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '1')
                  "
                  :file-list="fileList_1"
                  :on-change="
                    (file, fileList) =>
                      otherSectionFile(file, fileList, '住家照片')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="学生卧室">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '2')
                  "
                  :file-list="fileList_2"
                  :on-change="
                    (file, fileList) =>
                      otherSectionFile(file, fileList, '学生卧室')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="起居室">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '3')
                  "
                  :file-list="fileList_3"
                  :on-change="
                    (file, fileList) =>
                      otherSectionFile(file, fileList, '起居室')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="厨房">
                <el-upload
                  ref="upload"
                  action
                  :auto-upload="false"
                  :on-preview="handlePicPreview"
                  :on-remove="
                    (file, fileList) => handleRemove(file, fileList, '4')
                  "
                  :file-list="fileList_4"
                  :on-change="
                    (file, fileList) => otherSectionFile(file, fileList, '厨房')
                  "
                  list-type="picture-card"
                  accept=".jpg,.jpeg,.png,.gif"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <!-- 图片预览  -->
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
    </div>
    <div class="btnBox">
      <el-button
        round
        type="primary"
        :loading="submitting"
        :disabled="uploadLoading || submitting"
        @click="submitForm('ruleForm')"
        >保存修改</el-button
      >
      <el-button round @click="back()">返回</el-button>
    </div>
  </div>
</template>

<script>
import {
  addAndEdit,
  getHouseDetail,
  uploadImg,
  removeImg,
} from "../../../api/form";
import OSS from "ali-oss";
import axios from "axios";
export default {
  data() {
    return {
      getOSS: {
        client: null,
        selectedFile: null,
        bucketName: "ixlzj",
        objectPath: "live/", // 文件存储路径
        stsToken: null,
        accessKeyId: "",
        accessKeySecret: "",
        region: "",
      },

      SignUrl: "", //住家签约链接
      loading: false,
      uploadLoading: false,
      pendingUploadCount: 0,
      submitting: false,
      ruleForm: {
        housetype: "", // 房屋类型
        petsituation: "", // 猫
        dog: "", // 狗
        qita: "", // 其他宠物
        jsexperience: "", // 寄宿家庭经验
        children: "", // 子女情况
        ischildren: "", // 输入有几个孩子与你同住
        money: "", // 价格
        bedroom: "", // 卧室数量
        bathroom: "", // 卫浴数量
        nullbedroom: "", // 空卧室数量
        car: "", // 汽车数量
        duwei: "", // 独立卫浴
        facilities: "", // 包含设施
        iskeqian: "", // 房源状态（是否可签）
        video: "", // 视频链接
      },

      rules: {},
      facilities_options: [
        {
          value: "WIFI",
          label: "WIFI",
        },
        {
          value: "空调",
          label: "空调",
        },
        {
          value: "储物间/衣帽间",
          label: "储物间/衣帽间",
        },
        {
          value: "书桌/写字台",
          label: "书桌/写字台",
        },
        {
          value: "洗衣机",
          label: "洗衣机",
        },
        {
          value: "电视",
          label: "电视",
        },
        {
          value: "电话",
          label: "电话",
        },
        {
          value: "冰箱",
          label: "冰箱",
        },
      ],
      fileList_0: [], // 房屋外观
      fileList_1: [],
      fileList_2: [],
      fileList_3: [],
      fileList_4: [],
      fileList_5: [], //封面图
      AllFileList: [], // 数组合并
      otherFiles: null,
      dialogVisible: false,
      dialogImageUrl: "",
      delArray: [], // 删除图片
    };
  },
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.SignUrl = "http://sys.ixlzj.com/#/sign";
    this.GetOssToken();
    // 回显
    if (this.$route.query.id) {
      this.getDetail(this.$route.query.id);
    }
  },
  methods: {
    resetFileLists() {
      this.fileList_0 = [];
      this.fileList_1 = [];
      this.fileList_2 = [];
      this.fileList_3 = [];
      this.fileList_4 = [];
      this.fileList_5 = [];
      this.AllFileList = [];
    },
    selectFile(event) {
      this.getOSS.selectedFile = event.target.files[0];
      this.VideoLoading = this.$loading({
        lock: true,
        text: "视频上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.uploadFile();
    },

    async uploadFile(name) {
      if (!this.getOSS.selectedFile) {
        return;
      }

      const { accessKeyId, accessKeySecret, region, stsToken } = this.getOSS;

      this.getOSS.client = new OSS({
        accessKeyId,
        accessKeySecret,
        region,
        stsToken,
        bucket: this.getOSS.bucketName,
      });

      try {
        const objectName =
          this.getOSS.objectPath + Date.now() + this.getOSS.selectedFile.name;
        this.ruleForm.video =
          `https://ixlzj.oss-cn-beijing.aliyuncs.com/` + objectName;
        await this.getOSS.client.put(objectName, this.getOSS.selectedFile);
        console.log("文件上传成功：", objectName);
        this.$message({
          message: "恭喜你，视频上传成功",
          type: "success",
        });
        this.VideoLoading.close();
      } catch (error) {
        console.error("文件上传失败：", error);
        this.$message.error("视频文件上传失败,重新打开网页试试");
        this.VideoLoading.close();
        this.ruleForm.video = "";
      }
    },

    // 获取阿里云 oss 参数
    GetOssToken() {
      axios.post("https://upload.naaeus.com/getStsTokenOne").then((res) => {
        this.getOSS.accessKeyId = res.data.AccessKeyId;
        this.getOSS.accessKeySecret = res.data.AccessKeySecret;
        this.getOSS.stsToken = res.data.SecurityToken;
        this.getOSS.region = "oss-cn-beijing";
      });
    },
    //复制
    copy(text) {
      this.$copyText(text).then((res) => {
        alert("复制成功！");
        this.$message({
          message: "复制成功",
          type: "success",
        });
      });
    },
    // 回显
    getDetail(id) {
      this.loading = true;
      getHouseDetail({ id: id }).then((res) => {
        if (res.code == 200) {
          if (res.data != null) {
            if (res.data.js_facilities != null) {
              this.ruleForm.facilities = res.data.js_facilities.split(";"); // 包含设施
            }
            this.ruleForm.housetype = res.data.js_type; // 房屋类型
            this.ruleForm.petsituation = res.data.js_cat; // 猫
            this.ruleForm.dog = res.data.js_dog; // 狗
            this.ruleForm.qita = res.data.js_otherpets; // 其他
            this.ruleForm.jsexperience = res.data.js_experience; // 寄宿家庭经验
            this.ruleForm.children = res.data.ju_hzsl; // 子女情况
            this.ruleForm.ischildren = res.data.ju_tzhz; // 是否和子女同住
            this.ruleForm.money = res.data.js_pay; // 价格
            this.ruleForm.bedroom = res.data.js_bedroom; // 卧室数量
            this.ruleForm.bathroom = res.data.js_bathroom; // 卫浴数量
            this.ruleForm.nullbedroom = res.data.js_freebedroom; // 空卧室数量
            this.ruleForm.car = res.data.js_car; // 汽车数量
            this.ruleForm.duwei = res.data.js_diwy; // 独立卫浴
            this.ruleForm.iskeqian = res.data.sign; // 房源状态（是否可签）
            this.ruleForm.video = res.data.js_video; // 视频链接L
            this.loading = false;
            // 图片列表回显
            if (res.data.houseimg) {
              this.resetFileLists();
              for (var i = 0; i < res.data.houseimg.length; i++) {
                if (res.data.houseimg[i].img_type == "房屋外观") {
                  this.fileList_0.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                } else if (res.data.houseimg[i].img_type == "住家照片") {
                  this.fileList_1.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                } else if (res.data.houseimg[i].img_type == "学生卧室") {
                  this.fileList_2.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                } else if (res.data.houseimg[i].img_type == "起居室") {
                  this.fileList_3.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                } else if (res.data.houseimg[i].img_type == "厨房") {
                  this.fileList_4.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                } else if (res.data.houseimg[i].img_type == "封面图") {
                  this.fileList_5.push({
                    img_address: res.data.houseimg[i].img_address,
                    url: res.data.houseimg[i].imgs,
                    house_id: res.data.houseimg[i].house_id,
                    img_type: res.data.houseimg[i].img_type,
                    id: res.data.houseimg[i].id,
                    status: "success",
                  });
                }
              }

              // 数组合并
              this.AllFileList = this.fileList_0
                .concat(this.fileList_1)
                .concat(this.fileList_2)
                .concat(this.fileList_3)
                .concat(this.fileList_4)
                .concat(this.fileList_5);
            }
          }
        }
      });
    },
    // 图片预览
    handlePicPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    getImageListKey(type) {
      const map = {
        0: "fileList_0",
        1: "fileList_1",
        2: "fileList_2",
        3: "fileList_3",
        4: "fileList_4",
        5: "fileList_5",
        房屋外观: "fileList_0",
        住家照片: "fileList_1",
        学生卧室: "fileList_2",
        起居室: "fileList_3",
        厨房: "fileList_4",
        封面图: "fileList_5",
      };

      return map[type];
    },
    normalizeFileList(fileList) {
      const seen = new Set();

      return fileList.filter((file) => {
        if (file.status === "removed") {
          return false;
        }

        const key = file.img_address || file.url || file.uid;
        if (!key || seen.has(key)) {
          return false;
        }

        seen.add(key);
        return true;
      });
    },
    syncImageList(type, fileList) {
      const key = this.getImageListKey(type);
      if (key) {
        // 展示层保留每一条数据库记录，方便逐条删除历史重复图片。
        // 真正的防重只在提交 payload 时处理，不能在这里隐藏重复卡片。
        this[key] = fileList.filter((file) => file.status !== "removed");
      }
    },
    beginImageUpload() {
      this.pendingUploadCount += 1;
      this.uploadLoading = true;
    },
    finishImageUpload() {
      this.pendingUploadCount = Math.max(0, this.pendingUploadCount - 1);
      this.uploadLoading = this.pendingUploadCount > 0;
    },
    async otherSectionFile(file, fileList, type) {
      if (!file.raw || file.img_address || file.uploading) {
        this.syncImageList(type, fileList);
        return;
      }

      file.uploading = true;
      this.beginImageUpload();

      const formData = new FormData();
      formData.append("img", file.raw);

      try {
        const res = await uploadImg(formData);
       

        if (res.code === 200) {
          this.$message.success("上传成功");
          // ⭐ 给 file 对象补充后端所需字段
          file.url = res.data.url;
          file.img_address = res.data.path;
          file.house_id = this.$route.query.id;
          file.img_type = type;
          file.status = "success"; // 标记上传成功
          this.syncImageList(type, fileList);
        } else {
          file.status = "fail";
          this.syncImageList(type, fileList);
          this.$message.error("上传失败");
        }
      } catch (err) {
        file.status = "fail";
        this.syncImageList(type, fileList);
        this.$message.error("上传失败");
      } finally {
        file.uploading = false;
        this.finishImageUpload();
      }
    },

    handleRemove(file, fileList, type) {
      // 标记删除状态（可选）
      file.status = "removed";
      this.syncImageList(type, fileList);

      if (file.img_address || file.id) {
        removeImg({ imgname: file.img_address, id: file.id })
          .then(() => this.$message.success("删除成功"))
          .catch(() => this.$message.error("删除失败"));
      }
    },

    // 表单提交
    submitForm(formName) {
      if (this.submitting) {
        return;
      }

      if (this.pendingUploadCount > 0) {
        this.$message.warning("图片仍在上传，请上传完成后再保存");
        return;
      }

      // 校验期间也要锁定按钮，避免快速双击同时进入两个校验回调。
      this.submitting = true;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if(this.fileList_1 == ''){
          //     this.$message({
          //         message:'未上传家庭成员照片',
          //         type:'error'
          //     })
          //     return
          // }
          // if(this.fileList_2 == ''){
          //     this.$message({
          //         message:'未上传学生卧室照片',
          //         type:'error'
          //     })
          //     return
          // }
          // if(this.fileList_3 == ''){
          //     this.$message({
          //         message:'未上传起居室照片',
          //         type:'error'
          //     })
          //     return
          // }
          // if(this.fileList_4 == ''){
          //     this.$message({
          //         message:'未上传厨房照片',
          //         type:'error'
          //     })
          //     return
          // }
          // 添加、编辑

          // 合并六个区域
          const rawAll = [
            ...this.fileList_0,
            ...this.fileList_1,
            ...this.fileList_2,
            ...this.fileList_3,
            ...this.fileList_4,
            ...this.fileList_5,
          ];

          // 生成干净对象数组，只保留后端需要的字段
          this.AllFileList = this.normalizeFileList(rawAll)
            .filter((f) => f.status === "success" && f.img_address) // 只保留上传成功
            .map((f) => ({
              img_address: f.img_address,
              url: f.url, //
              house_id: f.house_id,
              img_type: f.img_type,
              uid: f.uid, // el-upload 自动生成的 uid
              status: f.status, // 上传状态
              id: f.id || "",
            }));
          addAndEdit({
            id: this.$route.query.id,
            js_type: this.ruleForm.housetype,
            js_cat: this.ruleForm.petsituation,
            js_dog: this.ruleForm.dog,
            js_otherpets: this.ruleForm.qita,
            js_experience: this.ruleForm.jsexperience,
            ju_hzsl: this.ruleForm.children,
            ju_tzhz: this.ruleForm.ischildren,
            js_Pay: this.ruleForm.money,
            js_bedroom: this.ruleForm.bedroom,
            js_bathroom: this.ruleForm.bathroom,
            js_freebedroom: this.ruleForm.nullbedroom,
            js_car: this.ruleForm.car,
            js_diwy: this.ruleForm.duwei,
            js_facilities: this.ruleForm.facilities.join(";"),
            sign: this.ruleForm.iskeqian,
            js_video: this.ruleForm.video,
            uploadImg: this.AllFileList,
          }).then((res) => {
            if (res.code == 200) {
              this.$message({
                message: "保存成功，继续下一步",
                type: "success",
              });
              // 修改步骤条状态
              this.$emit("stepactive", 2);
            }
          }).catch(() => {
            // 接口层已统一展示错误信息，这里只负责恢复提交状态。
          }).finally(() => {
            this.submitting = false;
          });
        } else {
          this.submitting = false;
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 返回上一步
    back() {
      // 修改步骤条状态
      this.$emit("stepactive", 0);
    },
  },
};
</script>
<style lang="scss" scoped>
/* @import url(); 引入css类 */
// form
.bg-white {
  background: #ffffff;
}
::v-deep .el-upload-list--picture-card .el-upload-list__item-thumbnail {
  object-fit: cover;
}
.bigTit {
  font-size: 20px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #1e1e1e;
  border-bottom: 1px solid #efefef;
  padding: 0px 0 22px 0;
  margin-bottom: 45px;
}
.formBox {
  padding-top: 35px;
}
.demo-ruleForm {
  .paddingleft {
    padding-left: 45px;
  }
  .padding45 {
    padding: 45px 0 20px 45px;
  }
  .padding45-2 {
    padding: 45px 0 0 45px;
  }
  .rowwhitetopbor {
    padding-left: 45px;
    border-top: 20px solid #fafafa;
    padding-top: 45px;
  }
  .rowwhitebombor {
    padding-left: 45px;
    border-bottom: 20px solid #fafafa;
    padding-bottom: 20px;
  }
}
::v-deep .el-input {
  width: 240px;
}
::v-deep .el-textarea__inner {
  background: #f8f8f8;
  width: 98%;
}
.btnBox {
  text-align: center;
  padding: 50px 0 40px 0;
}
.upload_video {
  display: flex;
  margin-bottom: 40px;
  p {
    font-size: 14px;
    color: #606266;
    margin: 0 20px 0 80px;
  }
}
</style>
